import { apolloClient } from "../../vue-apollo";
import {
    GET_USUARIO,
    GET_RECONOCIMIENTOS_PAGINA,
    GET_VALORES_RECONOCIMIENTOS,
    GET_RELACIONES_RECONOCIMIENTO,
    GET_USUARIOS_FOR_RECONOCER,
    GET_TOTAL_RECONOCIMIENTOS_POR_VALOR
} from "../../graphql/queries";
import {
    RECONOCER
} from "../../graphql/mutations";

export default {
    namespaced: true,
    state: {
        usuario: [],
        usuarios: [],
        reconocimientosPagina: { data: [] },
        valoresReconocimientos:[],
        relacionesReconocimientos: [],
        totalesReconocimientosPorValor: []
    },
    getters: {
    },
    mutations: {
        SET_USER(state, userActual){
            state.usuario = userActual;
        },

        SET_USERS(state, usuarios){
            usuarios.forEach(element => {
                element.active = false;
                if (Array.isArray(element.cargo) && element.cargo[0]==null && typeof element.cargo[0]=== 'object'){
                        element.cargo[0] = {
                            id_cargo : '0',
                            nombre_cargo : "S/N"
                        }
                    }
                    if(Array.isArray(element.gerencia) && element.gerencia[0]==null && typeof element.gerencia[0]=== 'object'){
                            element.gerencia[0] = {
                            id_gerencia : '0',
                            nombre_gerencia : "S/N"
                        }
                    }
                    if(Array.isArray(element.grupo) && element.grupo[0]==null && typeof element.grupo[0]=== 'object'){
                            element.grupo[0] = {
                            id_grupo: "0"
                        }
                    }
                    if(Array.isArray(element.sucursal) && element.sucursal[0]==null && typeof element.sucursal[0]=== 'object'){
                            element.sucursal[0] = {
                            id_sucursal : '0',
                            nombre_sucursal : "S/N"
                        }
                    }
                    if(Array.isArray(element.turno) && element.turno[0]==null && typeof element.turno[0]=== 'object'){
                            element.turno[0] = {
                            id_turno : '0',
                            nombre_turno : "S/N"
                        }
                    }
            });
            state.usuarios = usuarios;
        },

        SET_PAGINA_RECONOCIMIENTOS(state, paginasReconoce){
            Object.assign(state.reconocimientosPagina, paginasReconoce[0], { pagina: paginasReconoce[1] });
        },

        SET_LIKE_RECONOCIMIENTO(state, likeResult){
            let reconocimiento_index = state.reconocimientosPagina.data.findIndex(r => r.id_reconocimiento == likeResult.id_objeto);
            if (reconocimiento_index != undefined) {
                state.reconocimientosPagina.data[reconocimiento_index].likes = state.reconocimientosPagina.data[reconocimiento_index].likes ?? [];
                state.reconocimientosPagina.data[reconocimiento_index].likes.unshift({ id_like: likeResult.id_like })
                state.reconocimientosPagina.data[reconocimiento_index].confirm_like = { id_like: likeResult.id_like };
            }
        },
        REMOVE_LIKE_RECONOCIMIENTO(state, likeResult){
            let reconocimiento_index = state.reconocimientosPagina.data.findIndex(r => r.id_reconocimiento == likeResult.id_objeto);
            if (reconocimiento_index != undefined) {
                state.reconocimientosPagina.data[reconocimiento_index].likes = state.reconocimientosPagina.data[reconocimiento_index].likes.filter(like => like.id_like !== likeResult.id_like);
                state.reconocimientosPagina.data[reconocimiento_index].confirm_like = null
            }
        },
        SET_VALORES_RECONOCIMIENTOS(state, valores){
            state.valoresReconocimientos = valores;

        },

        SET_NUEVO_RECONOCIMIENTO(state, reconocido){
            state.reconocimientosPagina.data.unshift(reconocido);
            state.reconocimientosPagina.count = +state.reconocimientosPagina.count + 1;
        },

        SET_RELACIONES_RECONOCE(state, relaciones){
            state.relacionesReconocimientos = relaciones;
        },
        SET_TOTAL_RECONOCIMIENTOS_POR_VALOR(state, totales) {
            state.totalesReconocimientosPorValor = totales;
        }
    },
    actions: {
        async getUserActual({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_USUARIO,
                variables: data_
            }
            try {
                const res = await apolloClient.query(params);
                if (!res.loading) response = res.data.usuario;
                commit("SET_USER", response);
            } catch(e){
                console.log("Falla error, getUserActual ", e);
            }
            return response;
        },

        async getUsuariosReconocer({ commit }, data_){
            const params = {
                query: GET_USUARIOS_FOR_RECONOCER,
                variables: data_
            }
            let response = null;
            try {
                const res = await apolloClient.query(params);
                if (!res.loading) response = res.data.usuarios;
                commit("SET_USERS", response);
            } catch(e) {
                console.log("Falla error, getUsuariosReconocer ", e);
            }
            return response;
        },

        async getReconocimientosPagina({ commit }, data_){
            const params = {
                query: GET_RECONOCIMIENTOS_PAGINA,
                variables: data_
            }
            let response = null;
            try {
                const res = await apolloClient.query(params)
                if (!res.loading) response = res.data.listReconocimientos;
                commit("SET_PAGINA_RECONOCIMIENTOS", [response, data_.pagina]);
            } catch(e) {
                console.log("Falla error, getReconocimientosPagina ", e);
            }
            return response;
        },

        async addLikeReconocimiento({ commit, dispatch }, payload){
            Object.assign(payload, {
                id_modulo: "4",
                id_subobjeto: "0"
            });
            const response = await dispatch("LikesModule/darLikeAction", payload, { root: true })
            commit("SET_LIKE_RECONOCIMIENTO", Object.assign(response, payload));
            return response;
        },

        
        async delLikeReconocimiento({ commit, dispatch }, payload){
            Object.assign(payload, {
                id_modulo: "4",
                id_subobjeto: "0"
            });
            const response = await dispatch("LikesModule/quitarLikeAction", payload, { root: true })
            commit("REMOVE_LIKE_RECONOCIMIENTO", Object.assign(response, payload));
            return response;

        },

        async getTotalReconocimientoPorValor({commit}, data_){
            const params = {
                query: GET_TOTAL_RECONOCIMIENTOS_POR_VALOR,
                variables: data_
            }
            let response = null;
            try {
                const res = await apolloClient.query(params);
                if (!res.loading) response = res.data.totalReconocimientoPorValor;
                commit("SET_TOTAL_RECONOCIMIENTOS_POR_VALOR", response);
            } catch(e) {
                console.log("Falla metodo getTotalReconocimientoPorValor: ", e);
            }
            return response;
        },

        async getValoresReconoce({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_VALORES_RECONOCIMIENTOS,
                variables: data_
            }
            try {
                const res = await apolloClient.query(params);
                if (!res.loading) response = res.data.valoresReconocimientos;
                commit("SET_VALORES_RECONOCIMIENTOS", response);
            } catch(e) {
                console.log("Falla error, getValoresReconoce ", e);
            }
            return response;
            
            
        },

        async getRelacionesReconocimiento({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_RELACIONES_RECONOCIMIENTO,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server getRelacionesReconocimiento: ", res.data.relacionesReconocimientos);
                if (!res.loading) response = res.data.relacionesReconocimientos;
            });
            }
            catch(e){
            console.log("Falla error, getRelacionesReconocimiento ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_RELACIONES_RECONOCE", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
            
        },

        async crearReconocimiento({ commit }, data_){
            let response = null;
            let params = {
                mutation: RECONOCER,
                variables: data_
            }
            try {
                const res = await apolloClient.mutate(params);
                if (!res.loading) response = res.data.reconocer;
                commit("SET_NUEVO_RECONOCIMIENTO", response);
            } catch(e) {
                console.log("Falla metodo crearReconocimiento: ", e);
            }
            return response;
        },
    }
};